import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useRegion } from '@/hooks/useRegion';
import { useTranslation } from 'react-i18next';

interface ISubsidiyaRegionSelect {
  value?: string;
  onChange: (value: string | undefined) => void;
}

export const SubsidiyaRegionSelect = ({
  value,
  onChange,
}: ISubsidiyaRegionSelect) => {
  const { t } = useTranslation();
  const { data: regions } = useRegion();

  return (
    <Select
      value={value || 'all'}
      onValueChange={(next) => onChange(next === 'all' ? undefined : next)}
    >
      <SelectTrigger className="h-10 w-[200px] rounded-lg border-border bg-card text-foreground">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{t('subsidiya_nationwide')}</SelectItem>
        {regions?.map((region) => (
          <SelectItem key={region.value} value={region.value}>
            {region.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
